/**
 *  create by tannc
 */

import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'

Vue.use(Vuex)
import  develop from './modules/develop'
import  user from './modules/user'
import  basicDataV3 from './modules/basicDataV3'

export default new Vuex.Store({
  plugins: [createPersistedState({
    key:"open_vuex",
    storage:window.localStorage
  })],//持久化
    modules: {
      develop,
      user,
      basicDataV3
    }
})



// WEBPACK FOOTER //
// ./src/vuex/index.js